import DateFilter from "@/components/date-filter";
import InventaireIndicateurs from "@/components/inventaire-indicateurs";
import InventaireFiltres from "@/components/inventaire-filtres";
import InventaireConfirmModal from "@/components/inventaire-confirm-modal";
import InventaireDetailModal from "@/components/inventaire-detail-modal";
import InventaireInfoModal from "@/components/inventaire-info-modal";
import { utilMixins } from '@/utils/utils-mixins'
import { parseBackendTimestamp } from '@/utils/backend-timestamp'
import { errorMessage, toNumber, formatMoney as _formatMoney, formatSignedMoney as _formatSignedMoney } from '@/utils/inventaire-helpers'
import store_inventaire  from '@/store/mods/stock/inventaires'
import $ from 'jquery'

export default {
    name: 'inventaire',
    components: {
        DateFilter,
        InventaireIndicateurs,
        InventaireFiltres,
        InventaireConfirmModal,
        InventaireDetailModal,
        InventaireInfoModal,
    },
    mixins: [utilMixins],
    props: [],
    data() {
        return {
            perPage: 10,
            filter: '',
            author_filter: '',
            curr_month: '',
            filter_date: '',
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,
            current_date_filter: {},
            is_loading: true,
            is_empty: false,
            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' },
            ],
            fields: [
                { key: 'reference', label: 'R\u00e9f\u00e9rence', thStyle: { width: '15%' } },
                { key: 'debut', label: 'Date', thStyle: { width: '14%' } },
                { key: 'auteur', label: 'Responsable', thStyle: { width: '14%' } },
                { key: 'stock', label: 'Stock', thStyle: { width: '15%' } },
                { key: 'total_valeur_ecart', label: '\u00c9cart financier', thStyle: { width: '15%' } },
                { key: 'statut', label: 'Statut', class: 'inventaire-status-column', thStyle: { width: '7%' } },
                { key: 'actions', label: 'Actions', class: 'text-center', thStyle: { width: '12%', minWidth: '120px' } },
            ],
            currentPage: 1,
            showDeleteModal: false,
            deleteTarget: null,
            showInfoModal: false,
            infoModalTitle: 'Information',
            infoModalMessage: '',
            showDetailModal: false,
            detailLoading: false,
            inventaires: []
        }
    },
    computed: {
        // inventaires() {
        //     const inventaires = this.$store.getters['inventaires'] || []

        //     if (this.isAdmin) {
        //         return inventaires.filter(item => ['soumis', 'demande'].includes(item.statut))
        //     }

        //     return inventaires
        // },
        inventaireAuthorOptions() {
            const authors = []
            const all = this.$store.getters['inventaires'] || []
            all.forEach((item) => {
                const name = item.auteur_nom || item.auteur || ''
                if (name && !authors.includes(name)) {
                    authors.push(name)
                }
            })
            return [{ id: '', lib: 'Choisir' }, ...authors.sort().map((author) => ({ id: author, lib: author }))]
        },
        filteredInventaires() {
            const query = (this.filter || '').toLowerCase()
            const author = this.selectedAuthorFilter().toLowerCase()

            return this.inventaires.filter((item) => {
                const searchableText = [
                    item.reference,
                    item.debut,
                    item.auteur_nom,
                    item.auteur,
                    item.stock_nom,
                    item.statut,
                ].join(' ').toLowerCase()
                const matchSearch = !query || searchableText.includes(query)

                const itemAuthor = (item.auteur_nom || item.auteur || '').toLowerCase()
                const matchAuthor = !author || itemAuthor.includes(author)

                return matchSearch && matchAuthor
            })
        },
        currentUserId() {
            const authInfo = this.$store.getters['authInfo']
            return authInfo && authInfo.user ? authInfo.user.id : null
        },
        activeRole() {
            return this.$store.getters['activeRole'] || {}
        },
        isAdmin() {
            return this.activeRole && this.activeRole.nom === 'ROLE_ADMINISTRATEUR'
        },
        deleteTargetLabel() {
            return this.deleteTarget ? this.numeroInventaire(this.deleteTarget) : ''
        },
        inventaireDetail() {
            return this.$store.getters['inventaire'] || {}
        },
        detailResultats() {
            return this.inventaireDetail && this.inventaireDetail.resultats ? this.inventaireDetail.resultats : []
        },
        recapValorisation() {
            return this.inventaires.reduce((acc, item) => {
                acc.total_valeur_numerique += toNumber(item.total_valeur_numerique)
                acc.total_valeur_physique += toNumber(item.total_valeur_physique)
                acc.total_valeur_ecart += toNumber(item.total_valeur_ecart)
                return acc
            }, {
                total_valeur_numerique: 0,
                total_valeur_physique: 0,
                total_valeur_ecart: 0,
            })
        },
        indicateurs() {
            return [
                {
                    label: 'Co\u00fbt th\u00e9orique',
                    hint: 'Co\u00fbt total des inventaires bas\u00e9 sur le prix public',
                    cardClass: 'card-box-shadow',
                    lignes: [{ valeur: this.formatCurrency(this.recapValorisation.total_valeur_numerique) }],
                },
                {
                    label: 'Valeur totale du stock',
                    hint: 'Valeur totale des inventaires bas\u00e9 sur le prix public',
                    cardClass: 'card-box-shadow',
                    lignes: [{ valeur: this.formatCurrency(this.recapValorisation.total_valeur_physique) }],
                },
                {
                    label: '\u00c9cart financier',
                    hint: 'Somme des \u00e9carts financiers des inventaires affich\u00e9s',
                    cardClass: 'card-box-shadow',
                    lignes: [{ valeur: this.formatCurrency(this.recapValorisation.total_valeur_ecart) }],
                },
            ]
        },
    },

    watch: {
        filter() {
            this.currentPage = 1
        },

        author_filter() {
            this.currentPage = 1
        },

        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data
            this.is_month = true
            this.loadInventaires()
        }
    },

    mounted() {
        this.$store.commit("SET_INVENTAIRES", []);

        this.current_date_filter = {
            month: '',
            one_date: this.setDates().today_date,
            from_date: '',
            to_date: '',
        }
        this.is_month = false

        this.loadInventaires()

        // if (this.has_two_currencies) {
        //     this.currency_info = this.$store.getters['info_currency']
        //     console.log(">> currency", this.currency_info);
        // }
    },

    methods: {
        numeroInventaire(item) {
            return item.reference || ('INV-' + String(item.id).padStart(4, '0'))
        },

        statutLabel(statut) {
            const labels = {
                demande: this.isAdmin ? 'Demand\u00e9' : '\u00c0 faire',
                soumis: 'Soumis',
                correction_autorisee: 'Correction autoris\u00e9e',
                retabli: 'R\u00e9tabli',
            }
            return labels[statut] || 'En cours'
        },

        statutClass(statut) {
            const classes = {
                demande: 'badge badge-xs badge-primary-light',
                soumis: 'badge badge-xs badge-warning-light',
                correction_autorisee: 'badge badge-xs badge-grey-light',
                retabli: 'badge badge-xs badge-success-light',
            }
            return classes[statut] || 'badge badge-xs badge-grey-light'
        },

        primaryActionLabel(item) {
            if (!item) {
                return 'Voir d\u00e9tail'
            }
            if (this.isAdmin) {
                return item.statut === 'demande' ? 'Modifier' : 'Voir d\u00e9tail'
            }
            if (item.statut === 'demande') {
                return 'Voir d\u00e9tail'
            }
            if (item.statut === 'correction_autorisee') {
                return 'Modifier'
            }
            return 'Voir d\u00e9tail'
        },

        primaryActionRoute(item) {
            if (!item) {
                return null
            }
            if (!this.isAdmin && item.statut === 'demande') {
                return '/inventaires/ajout?inventaire=' + item.id
            }
            return '/inventaires/' + item.id
        },

        valeurEcartClass(value) {
            const numericValue = Number(value)
            if (!Number.isFinite(numericValue) || numericValue === 0) return 'badge badge-xs badge-success-light'
            return numericValue > 0 ? 'badge badge-xs badge-primary-light' : 'badge badge-xs badge-danger-light'
        },

        formatMoney(value) {
            return _formatMoney(value, this.currencyLabel())
        },

        formatSignedMoney(value) {
            return _formatSignedMoney(value, this.currencyLabel())
        },

        currencyLabel() {
            if (this.currency_info && this.currency_info.principal_currency) {
                return this.currency_info.principal_currency
            }
            return this.principal_currency || ''
        },

        formatInventaireDate(dateStr) {
            if (!dateStr) return '-'
            const backendMatch = String(dateStr).match(/^(\d{2})-(\d{2})-(\d{4}) \u00e0 (\d{2}):(\d{2})/)
            if (backendMatch) {
                return `${backendMatch[1]}/${backendMatch[2]}/${backendMatch[3]} \u00e0 ${backendMatch[4]}h${backendMatch[5]}`
            }
            const date = parseBackendTimestamp(dateStr)
            if (Number.isNaN(date.getTime())) return dateStr
            const parts = this.getDatePartsInClinicTimezone(date)
            return `${parts.day}/${parts.month}/${parts.year} à ${parts.hour}h${parts.minute}`
        },

        selectedAuthorFilter() {
            if (!this.author_filter) {
                return ''
            }
            if (typeof this.author_filter === 'string') {
                return this.author_filter
            }
            if (this.author_filter.id === '') {
                return ''
            }
            return this.author_filter.lib || this.author_filter.id || ''
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false
            this.loadInventaires()
        },

        // filterByDate(date) {
        //     this.current_date_filter = {
        //         month: '',
        //         one_date: date.single_date || '',
        //         from_date: date.from_date || '',
        //         to_date: date.to_date || '',
        //     }
        //     this.filter_date = ''
        //     this.is_month = false
        //     this.curr_month = ''
        //     this.currentPage = 1
        //     this.loadInventaires()
        // },

        canDelete(item) {
            return (!this.isAdmin && item.statut === 'en_cours') || (this.isAdmin && item.statut === 'demande')
        },

        loadInventaires() {
            this.is_loading = true

            store_inventaire.getListeInventaire(this.current_date_filter).then((response) => {
                console.log("INV: ",this.inventaires);
                
                this.inventaires = response
                this.is_loading = false
                this.is_empty = this.inventaires.length === 0
            }).catch(() => {
                this.is_loading = false
            })
        },

        deleteInventaire(item) {
            if (!this.canDelete(item)) {
                return
            }
            this.deleteTarget = item
            this.showDeleteModal = true
        },

        closeDeleteModal() {
            this.showDeleteModal = false
            this.deleteTarget = null
        },

        async confirmDeleteInventaire() {
            const item = this.deleteTarget
            this.closeDeleteModal()
            try {
                await this.$store.dispatch('deleteInventaire', item.id)
                this.loadInventaires()
            } catch (error) {
                this.openInfoModal(errorMessage(error, "Impossible de supprimer l'inventaire"), 'Erreur')
            }
        },

        openInfoModal(message, title = 'Information') {
            this.infoModalMessage = message
            this.infoModalTitle = title
            this.showInfoModal = true
        },

        closeInfoModal() {
            this.showInfoModal = false
            this.infoModalMessage = ''
        },

        useDetailModal(item) {
            return !this.isAdmin && item && ['soumis', 'retabli'].includes(item.statut)
        },

        async openDetailModal(item) {
            this.showDetailModal = true
            this.detailLoading = true
            try {
                await this.$store.dispatch('getInventaire', item.id)
            } catch (error) {
                this.closeDetailModal()
                this.openInfoModal(errorMessage(error, "Impossible de charger l'inventaire"), 'Erreur')
            } finally {
                this.detailLoading = false
            }
        },

        closeDetailModal() {
            this.showDetailModal = false
            this.detailLoading = false
        },
    }
}
